import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { SupportingDocumentation } from "./supportingDocumentation";
import { createMutationObserver, formatWithThousandsSeparator } from "./utils";
import { outputDiv, appPayMethod, i18n, loading } from "commonAssets/js/constants";
import {
    createElement,
    clearMessage,
    toggleFieldWarning,
    toggleFieldError,
    validFloat,
    validInteger,
    validURL,
    validMin,
    validMax,
    validMinLength,
    validMaxLength,
    validPhone,
    validPrice,
    validRequire,
    validZipCode,
    validFileType,
    validFileSize,
    validMonth,
    validDate,
    validMinDate,
    validMaxDate,
    validGreaterThan,
    validLessThan,
    validRegex,
} from "commonAssets/js/helpers";
import { FormFields, FormFieldsLabel } from "./FormFields";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import { loadingGif } from "commonAssets/lib/loadingGif";
import {
    resolveClaimId,
    isExistingClaimResponse,
} from "./resolveClaimId";
import loadMember from "./loadMember";
import {
    DigitalDisbursements,
    dstMember,
} from "commonAssets/components/FormBase/DigitalDisbursements";
import { uploadFile } from "commonAssets/lib/uploadFile";
import { modal } from "commonAssets/lib/modal";

export class CustomSubmitClaim extends SubmitClaim {
    /**
     * Custom Submit Claim class.
     *
     * @param {Object} options - The options object.
     * @param {Object} options.config - The application claim form.
     * @param {Function?} options.validateForm - The validate form function.
     * @param {Function?} options.customInitClaim - The custom initialization function.
     * @param {Function?} options.customProcessClaim - The custom processing function.
     * @param {Function?} options.customLoadMember - The custom loading function.
     * @param {Function?} options.customDstProcess - The custom DST processing function.
     * @param {Function?} options.customAddClaimFile - The custom add claim file function.
     * @param {ErrorHandler?} options.errorHandler - The error handler.
     * @param {Function?} options.onTransactionRowAdded - The callback function.
     * @param {Function?} options.onTransactionRowRemoved - The callback function.
     * @param {Function?} options.onFormUnloaded - The callback function.
     */
    constructor({
        config,
        validateForm = null,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        customAddClaimFile = null,
        errorHandler = null,
        onTransactionRowAdded = null,
        onTransactionRowRemoved = null,
        onFormUnloaded = null,
        expectedClaimFormType = null,
    }) {
        super(
            null,
            null,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
        this.customInitClaim = customInitClaim
            ? customInitClaim.bind(null, this)
            : handleInitClaim.bind(this, validateForm);
        this.customProcessClaim = customProcessClaim
            ? customProcessClaim.bind(null, this)
            : handleProcessClaim.bind(this, validateForm);
        this.customAddClaimFile = customAddClaimFile
            ? customAddClaimFile.bind(null, this)
            : handleAddClaimFile.bind(this, validateForm);
        this.onTransactionRowAdded = onTransactionRowAdded;
        this.onTransactionRowRemoved = onTransactionRowRemoved;
        this.onFormUnloaded = onFormUnloaded;
        this.observer = createMutationObserver({
            target: outputDiv,
            handleMutations: this.handleMutations.bind(this),
        });
        this.formConfig = config;
        this.supportingDocumentation = {};
        this.expectedClaimFormType = expectedClaimFormType;
    }

    form() {
        this.init_claim(this.formConfig);
    }


    edit_claim(params) {
        console.log("[Edit Claim]");
        const notice = createElement(
            "p",
            [],
            [],
            i18n.getTranslation("claim_edit_notice")
        );
        const div = createElement(
            "div",
            {
                class: "my-3 text-center fw-bold text-info-emphasis text-uppercase",
                id: "editClaim",
            },
            [notice]
        );

        const guardRow = createElement(
            "div",
            { class: "row fs-5", id: "guardRow" },
            [this.notice_confirmation(params, "col")]
        );
        const form = createElement(
            "form",
            { class: "needs-validation", id: "guard", method: "post" },
            [guardRow]
        );
        const formContainer = createElement("div", [], [form]);

        outputDiv.appendChild(div);

        document
            .getElementById("editClaimBtn")
            .addEventListener("click", () => {
                modal(
                    i18n.getTranslation("claim_edit_title"),
                    formContainer.innerHTML
                );

                // Allows for DOM to load
                setTimeout(() => {
                    const zero_zero_id =
                        document.getElementById("zero_zero_id");
                    const confirmation_code =
                        document.getElementById("confirmation_code");

                    // Notice Id and Confirmation Code
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        input.addEventListener("change", validateField);
                    });

                    // Validate Guard Fields
                    document
                        .getElementById("guard")
                        .addEventListener("submit", (e) => {
                            div.remove(); // remove the editClaim div upon click

                            e.preventDefault();

                            let valid = true;
                            const member = {
                                domain: this.claim.data.domain,
                                zero_zero_id: zero_zero_id.value.toUpperCase(),
                                confirmation_code: confirmation_code.value,
                            };

                            clearMessage();

                            // Validate guard fields
                            [zero_zero_id, confirmation_code].forEach(
                                function (input) {
                                    valid = validateField(input) && valid;
                                }
                            );
                            if (!valid) return;

                            loadingGif(loading, "show");

                            // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                            this.claim.api
                                .classMemberPost({}, member)
                                .then((result) => {
                                    console.log("Class member data init...");

                                    let claim_deadline;
                                    if (Boolean(result.data.claim_deadline)) {
                                        claim_deadline =
                                            result.data.claim_deadline;
                                    }

                                    const container = createElement("div", {
                                        class: "display-form",
                                    });

                                    // Check for error message
                                    if (result.data.error) {
                                        toggleFieldError(
                                            zero_zero_id,
                                            true,
                                            ""
                                        );
                                        toggleFieldError(
                                            confirmation_code,
                                            true,
                                            ""
                                        );
                                        this.errorHandler.log_exception(
                                            new Error(
                                                "Error fetching class member",
                                                { cause: result }
                                            )
                                        );
                                        this.errorHandler.display_modal(result);
                                        return;
                                    }

                                    // Only generic Individual claims can be edited
                                    if (this.expectedClaimFormType) {
                                        const claimFields =
                                            result.data.claim_fields || [];
                                        const formTypeField = claimFields.find(
                                            (f) => f.name === "Claim Form Type"
                                        );
                                        const actualType = formTypeField
                                            ? formTypeField.value
                                            : null;
                                        if (
                                            actualType !==
                                                this.expectedClaimFormType || !["generic", "test"].includes(result.data.claim_type.toLowerCase())
                                        ) {
                                            loadingGif(loading, "hide", 250);
                                            modal(
                                                i18n.getTranslation("error"),
                                                "This claim cannot be edited."
                                            );
                                            return;
                                        }
                                    }

                                    // Add notice id and confirmation code to claim data
                                    this.claim.data.correlation_id =
                                        result.data.correlation_id;
                                    this.claim.data.zero_zero_id =
                                        member.zero_zero_id;
                                    this.claim.data.confirmation_code =
                                        member.confirmation_code;

                                    const form = params;

                                    // Check for existing claim number and add to claim data.
                                    // Commenting this out left claim.data.claim_id unset, so
                                    // post_claim kept flags.method at claimsV4Post and every
                                    // edit went out as a POST -- which postClaim then dropped
                                    // on the duplicate-key catch.
                                    if (result.data.claim_id) {
                                        this.claim.data.claim_id =
                                            result.data.claim_id;
                                        this.claim.class_member = result.data;
                                        this.claim.flags.editing = true;

                                        loadingGif(loading, "show");
                                        outputDiv.innerHTML = ``;
                                        loadingGif(loading, "hide", 250);

                                        this.send_otp(
                                            form,
                                            container,
                                            result.data,
                                            claim_deadline
                                        );
                                        return;
                                    }

                                    // Hide guard
                                    document
                                        .querySelector(
                                            '[data-bs-dismiss="modal"]'
                                        )
                                        .click();

                                    // Load member data into form
                                    loadMember(result.data);

                                    // Custom load claim
                                    if (this.customLoadMember != null) {
                                        // this.customLoadMember(this.claim); ada compliance updates - commented out
                                        this.customLoadMember(result.data); // ada compliance updates - changed
                                    }

                                    loadingGif(loading, "hide", 250);
                                })
                                .catch((error) => {
                                    this.errorHandler.log_exception(
                                        new Error(
                                            "Error fetching class member",
                                            { cause: error }
                                        )
                                    );
                                    this.errorHandler.display_modal(error);
                                });
                        });
                }, 1000);
            });
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                // Claim Deadline - Default Pacific DateTime
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                // Error Handling
                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                /**
                 * Claim Guard
                 */
                if (form.form_options.notice_confirmation.display === true) {
                    // Guard
                    container.appendChild(this.guard(form, datetime));
                    outputDiv.appendChild(container);

                    const zero_zero_id =
                        document.getElementById("zero_zero_id");
                    const confirmation_code =
                        document.getElementById("confirmation_code");
                    const skip_guard = document.getElementById("skip-guard");

                    // Notice Id and Confirmation Code
                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        input.addEventListener("change", validateField);
                    });

                    // Skip Guard
                    if (skip_guard) {
                        skip_guard.addEventListener("click", () => {
                            // Hide guard
                            // document.getElementById('guard').classList.add("d-none");
                            document.getElementById("guard").remove();
                            // New Claim Form
                            container.appendChild(
                                this.claim_form(form, datetime)
                            );
                            container.scrollIntoView({ behavior: "smooth" });
                            outputDiv.appendChild(container);

                            // Init claim fields
                            this.init_claim_fields(
                                this.claim,
                                form,
                                claim_deadline
                            );
                        });
                    }

                    // ada compliance updates - added
                    // if input#submit-guard was clicked add .was-verified to form#guard
                    document
                        .getElementById("submit-guard")
                        .addEventListener("click", () => {
                            document
                                .getElementById("guard")
                                .classList.add("was-validated");
                            // TODO: add required text to labels
                        });

                    // Validate Guard Fields
                    document
                        .getElementById("guard")
                        .addEventListener("submit", (e) => {
                            e.preventDefault();

                            let valid = true;
                            const member = {
                                domain: this.claim.data.domain,
                                zero_zero_id: zero_zero_id.value.toUpperCase(),
                                confirmation_code: confirmation_code.value,
                            };

                            clearMessage();

                            // Validate guard fields
                            [zero_zero_id, confirmation_code].forEach(
                                function (input) {
                                    valid = validateField(input) && valid;
                                }
                            );
                            if (!valid) return;

                            loadingGif(loading, "show");

                            // Retrieve class member data (use POST to pass notice id and confirmation code privately)
                            this.claim.api
                                .classMemberPost({}, member)
                                .then((result) => {
                                    // Check for error message
                                    if (result.data.error) {
                                        toggleFieldError(
                                            zero_zero_id,
                                            true,
                                            ""
                                        );
                                        toggleFieldError(
                                            confirmation_code,
                                            true,
                                            ""
                                        );
                                        this.errorHandler.log_exception(
                                            new Error(
                                                "Error loading class member",
                                                { cause: result }
                                            )
                                        );
                                        this.errorHandler.display_modal(result);
                                        return;
                                    }

                                    // Add notice id and confirmation code to claim data
                                    this.claim.data.zero_zero_id =
                                        member.zero_zero_id;
                                    this.claim.data.confirmation_code =
                                        member.confirmation_code;

                                    // Define the environment for the OTP
                                    const environment =
                                        this.claim.data.domain.split(".")[0]; // ada compliance - added

                                    // Check for existing claim number and add to claim data.
                                    // See the matching block in edit_claim -- while this was
                                    // commented out the edit could only ever be POSTed.
                                    if (result.data.claim_id) {
                                        this.claim.data.claim_id =
                                            result.data.claim_id;
                                        this.claim.class_member = result.data;
                                        this.claim.flags.editing = true;
                                        if (environment !== "local") {
                                            this.send_otp(
                                                form,
                                                container,
                                                result.data,
                                                claim_deadline
                                            );
                                            return;
                                        }
                                    }

                                    // Populate claim form
                                    this.populate_claim_form(
                                        form,
                                        container,
                                        result.data,
                                        claim_deadline
                                    );
                                })
                                .catch((error) => {
                                    this.errorHandler.log_exception(
                                        new Error(
                                            "Error loading class member",
                                            { cause: error }
                                        )
                                    );
                                    this.errorHandler.display_modal(error);
                                });
                        });
                } else {
                    /**
                     * No Claim Guard
                     */
                    // Edit claim link
                    this.edit_claim(form);

                    // New Claim Form
                    const deadlineSpan = uniformClaimDeadline(claim_deadline);
                    container.appendChild(this.claim_form(form, deadlineSpan));
                    outputDiv.appendChild(container);

                    // Init claim fields
                    this.init_claim_fields(this.claim, form, claim_deadline);
                }

                loadingGif(loading, "hide", 250);
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", { cause: error })
                );
                this.errorHandler.display(error);
            });
    }

    claim_fields(params) {
        const container = createElement("div");

        let fieldID = 0; //
        params.claim_fields.forEach((field) => {
            const className = field.className ? field.className : ``;

            const div = createElement("div", {
                class: field.parentClass ? field.parentClass : "mb-3 _wrapper",
                "data-field-id":
                    "_" + (field.name ? field.name : "_wrapper_" + fieldID),
            });
            const element = FormFields(field, className, fieldID);
            FormFieldsLabel(field, fieldID, div);

            // Set data-label if it exists
            if (field.dataLabel) {
                element.setAttribute("data-label", field.dataLabel);
            }

            div.append(element);
            container.appendChild(div);
            fieldID++;
        });

        return container;
    }

    /**
     * Override claim_contact_fields to properly render intl-phone-input custom elements.
     *
     * @param {Object} params - Form parameters containing contact_information
     * @returns {HTMLElement} Container with rendered contact fields
     */
    claim_contact_fields(params) {
        const parent = createElement("div", {
            class: "row row-cols-1 row-cols-md-2",
        });
        let fieldID = 0;
        params.contact_information.forEach((field) => {
            let validation;
            const d_none =
                field.name === "province" || field.name === "postal_code"
                    ? " d-none"
                    : "";

            const input = FormFields(
                field,
                "",
                fieldID,
                null,
                validation,
                parent
            );
            input.setAttribute("data-contact-label", field.label);
            input.removeAttribute("data-label");

            const div = createElement(
                "div",
                {
                    class: "col mb-3 divContactField" + d_none,
                    id: "divContactField_" + fieldID,
                },
                [
                    createElement(
                        "label",
                        { for: field.name },
                        [],
                        `${field.label}${field.required ? "*" : ""} <span class="error"></span>`
                    ),
                    input,
                ]
            );
            parent.appendChild(div);
            fieldID++;
        });
        return parent;
    }

    /**
     * Creates a claim form element with the given parameters and additional parameters.
     *
     * @param {Object} params - The form parameters.
     * @param {Object} additionalParams - Additional parameters for the form.
     * @returns {HTMLElement} - The created form element.
     */
    claim_form(params, additionalParams) {
        console.log("[claim_form]");
        // update the claim form deadline
        const deadline_heading =
            params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(
            deadline_heading,
            "text/html"
        );
        const deadline_date_string = deadline_string.querySelector(
            "span#deadline_datetime"
        );
        // if deadline_date_string is null, then the deadline is not set
        // the if condition was added due to error in i18n translation
        // TODO: remove this if condition after fixing the i18n translation
        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // Create an array of form elements
        const formElements = [
            createElement(
                "h3",
                {
                    class: "text-center mb-3",
                    id: "claimFormDeadline",
                },
                [],
                deadline_string.body.innerHTML
            ),
            createElement(
                "div",
                {
                    class: "alert alert-info text-center fw-bold text-dark",
                    id: "confirmation-email-alert",
                    role: "alert",
                },
                [],
                params.form_options.claim_form.confirmation_email_notice
            ),
            this.claim_instructions(params),
            createElement(
                "div",
                {
                    class: "bg-light text-dark border rounded p-3 mb-5",
                },
                [
                    this.claim_contact_information(params),
                    this.claim_fieldset(params),
                ],
                params.form_options.claim_form.data_transfer_notice
            ),
            this.claim_transactions(params),
        ];

        // Add documentation sections
        const documentationSections = Object.entries(params.claim_upload).map(
            ([id, value]) => this.claim_documentation({ id, ...value })
        );
        formElements.push(...documentationSections);

        // Add payment method if enabled
        if (appPayMethod) {
            formElements.push(DigitalDisbursements(params));
        }

        // Add certification section
        formElements.push(this.claim_certification(params));

        // Create the form with all elements
        const form = createElement(
            "form",
            {
                class: "needs-validation",
                id: "form",
                method: "post",
            },
            formElements
        );

        this.formElement = form;
        return form;
    }

    claim_transactions(params) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        // Main container for all transaction groups
        const mainContainer = createElement("div", {
            id: "transactions",
        });

        // Group tables by part prefix (part_b_, part_c_, part_d_)
        const claim_transactions = params.claim_transactions;
        const groups = {};
        claim_transactions.forEach((table) => {
            const partMatch = table.id?.match(/^(part_[a-z])_/);
            const partKey = partMatch ? partMatch[1] : "part_b"; // default to part_b
            if (!groups[partKey]) groups[partKey] = [];
            groups[partKey].push(table);
        });

        // Create container for each group
        let tableID = 0;
        Object.keys(groups)
            .sort()
            .forEach((partKey) => {
                const groupContainer = createElement(
                    "div",
                    {
                        class: "bg-light text-dark border rounded p-3 mb-5",
                        id: `transactions_${partKey}`,
                    },
                    [
                        createElement(
                            "div",
                            { class: "h3 mb-3 formTitle" },
                            [],
                            params.form_options.transactions[`${partKey}_title`]
                        ),
                        createElement(
                            "div",
                            { class: "mb-3 formBody" },
                            [],
                            params.form_options.transactions[`${partKey}_body`]
                        ),
                    ]
                );

                // Render each table in this group
                let isFirstInGroup = true;
                let tableIndexInPart = 0;
                // Calculate part index: 'b'=1, 'c'=2, 'd'=3, etc.
                const partIndex = partKey.charCodeAt(5) - 97;
                groups[partKey].forEach((table) => {
                    tableID++; // Begin count at 1.
                    tableIndexInPart++;
                    // Calculate item ID offset: (part * 1000) + (table * 100)
                    const itemIdOffset =
                        partIndex * 1000 + tableIndexInPart * 100;

                    // Add separator line between tables (not before the first one in group)
                    if (!isFirstInGroup) {
                        const separator = createElement("hr", {
                            class: "my-4",
                        });
                        groupContainer.appendChild(separator);
                    }
                    isFirstInGroup = false;

                    // Title as h2 above the table
                    const tableTitle = createElement(
                        "h2",
                        { class: "h5 fw-bold mb-2" },
                        [],
                        table.name
                    );
                    groupContainer.appendChild(tableTitle);

                    // Description as paragraph below the title
                    if (table.description) {
                        const tableDescription = createElement(
                            "p",
                            { class: "mb-3 text-muted" },
                            [],
                            table.description
                        );
                        groupContainer.appendChild(tableDescription);
                    }

                    // <div class="table-responsive"></div>
                    const divResponsiveTable = createElement("div", {
                        class: "table-responsive mb-3",
                        id: "table_responsive_" + tableID,
                    });

                    // <table class="table transactions"></table>
                    const tableTransaction = createElement(
                        "table",
                        {
                            class: "table table-hover transactions",
                            id: "transactions_" + tableID,
                            "data-table-name": table.name,
                            "data-table-id": tableID,
                        },
                        []
                    );
                    divResponsiveTable.appendChild(tableTransaction);

                    // <thead class="bg-dark text-light"></thead>
                    const tableTHEAD = createElement("thead", {
                        class: "table-dark text-light",
                    });
                    tableTransaction.appendChild(tableTHEAD);

                    // <tr> ...Table Data Cells... </tr>
                    const theadTR = createElement("tr");
                    tableTHEAD.appendChild(theadTR);

                    // <th scope="col"></th>
                    table.columns.forEach((col) => {
                        const column = createElement(
                            "th",
                            { scope: "col" },
                            [],
                            col.title
                        );
                        theadTR.appendChild(column);

                        if (Boolean(col.body)) {
                            const helper = createElement(
                                "span",
                                {
                                    class: "d-block fw-normal",
                                    style: "font-size:13px;",
                                },
                                [],
                                col.body
                            );
                            column.appendChild(helper);
                        }
                    });

                    // <tbody></tbody>
                    const tableTBODY = createElement("tbody");
                    tableTransaction.appendChild(tableTBODY);

                    // Add rows through a function, so we can attach a button.
                    const countRow = 1;
                    this.claim_transaction_row(
                        table,
                        tableTBODY,
                        tableID,
                        countRow,
                        itemIdOffset
                    );

                    const addButtonLabel = table.addButtonLabel || table.name;
                    const canChangeRows = table.canChangeRows !== false;
                    const add_row = createElement(
                        "div",
                        {
                            class: canChangeRows
                                ? "text-center"
                                : "text-center d-none",
                        },
                        [
                            createElement(
                                "a",
                                {
                                    class: "btn btn-primary m-1",
                                    id: "add_transactions_" + tableID,
                                    role: "button",
                                    tabindex: "0",
                                    "aria-label":
                                        i18n.getTranslation(
                                            "transaction_add_row"
                                        ) + table.name,
                                    tableID: tableID,
                                },
                                [],
                                `<i class="bi bi-plus-circle" tableID="${tableID}"></i> ${addButtonLabel}`
                            ),
                            createElement(
                                "a",
                                {
                                    // ada compliance updates - added
                                    class: "btn btn-danger m-1 disabled", // default to disabled
                                    id: "remove_transactions_" + tableID,
                                    role: "button",
                                    tabindex: "0",
                                    "aria-label": i18n.getTranslation(
                                        "transaction_delete_row"
                                    ),
                                    tableID: tableID,
                                },
                                [],
                                `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation("transaction_delete_row")}`
                            ),
                        ]
                    );

                    // ada compliance updates - added
                    if (canChangeRows) {
                        this.claim_transaction_row_buttons_events(
                            add_row,
                            table,
                            tableTBODY,
                            tableID,
                            countRow,
                            itemIdOffset
                        );
                    }

                    // Append the table to the group container
                    groupContainer.appendChild(divResponsiveTable);
                    groupContainer.appendChild(add_row);
                });

                // Append the group container to the main container
                mainContainer.appendChild(groupContainer);
            });

        return mainContainer;
    }

    /**
     * Adds a new transaction row to the given table.
     * Override to use numeric item-id and field.label as data key.
     *
     * @param {Object} table - The table configuration object.
     * @param {HTMLTableSectionElement} tableTBODY - The table body to add the row to.
     * @param {string} tableID - The numeric ID of the table.
     * @param {number} countRow - The count of the row.
     * @param {number} itemIdOffset - The item ID offset for this table (e.g., 1100, 1200, 2100).
     * @returns {Object} An object containing the table body and the fields row.
     */
    claim_transaction_row(table, tableTBODY, tableID, countRow, itemIdOffset) {
        const fieldsRow = createElement("tr", {
            class: "transaction-row",
            id: "transaction_row_" + tableID + "_" + countRow,
        });
        tableTBODY.appendChild(fieldsRow);

        let fieldID = 0;
        table.fields.forEach((field) => {
            fieldID++;
            // Store original name before mutation
            const originalFieldName = field.name;

            const td = createElement("td", {
                class: "transaction " + originalFieldName,
            });
            const element = createElement("div");
            const validation = field.validation;

            const formInput = FormFields(
                field,
                "",
                fieldID,
                element,
                validation,
                fieldsRow
            );

            // Set unique name for each field (append row number)
            field.name = originalFieldName + "__" + countRow;
            FormFieldsLabel(field, fieldID, element);

            // Set unique id for each field
            formInput.id = formInput.id + "__" + countRow;

            // Set item-id as numeric value: offset + row number
            // e.g., 1101, 1102, 1201, 2101, etc.
            formInput.setAttribute("item-id", itemIdOffset + countRow);

            // Set data-table-id for table identification during processing
            formInput.setAttribute("data-table-id", table.id);

            // Use field's label as the data key (human-readable)
            formInput.setAttribute("data-label", field.label);

            element.appendChild(formInput);
            td.appendChild(element);
            fieldsRow.appendChild(td);

            // Restore original name for next iteration/row
            field.name = originalFieldName;
        });
        return { tableTBODY, fieldsRow };
    }

    /**
     * Adds event listeners to the add and remove buttons of a claim transaction row.
     * Override to pass itemIdOffset when adding new rows.
     *
     * @param {Element} add_row - The add button element.
     * @param {Element} table - The table element.
     * @param {Element} tableTBODY - The table body element.
     * @param {string} tableID - The ID of the table.
     * @param {number} countRow - The current number of rows in the table.
     * @param {number} itemIdOffset - The item ID offset for this table.
     */
    claim_transaction_row_buttons_events(
        add_row,
        table,
        tableTBODY,
        tableID,
        countRow,
        itemIdOffset
    ) {
        // Add row for every click
        add_row.firstChild.addEventListener("click", (event) => {
            countRow++;
            const table_id = event.target.attributes.tableID.value;
            this.claim_transaction_row(
                table,
                tableTBODY,
                table_id,
                countRow,
                itemIdOffset
            );
            if (countRow > 1) {
                document
                    .querySelector(`#remove_transactions_${table_id}`)
                    .classList.remove("disabled");
            }
        });
        // Remove row for every click
        add_row.lastChild.addEventListener("click", (event) => {
            countRow--;
            const table_id = event.target.attributes.tableID.value;
            const tableEl = document.querySelector(`#transactions_${table_id}`);
            const table_rows = tableEl.rows.length;
            const table_tbody = tableEl.querySelector("tbody");
            table_tbody.removeChild(table_tbody.lastChild);
            if (table_rows === 3) {
                document
                    .querySelector(`#remove_transactions_${table_id}`)
                    .classList.add("disabled");
            }
        });
    }

    /**
     * Creates a documentation section for the claim form.
     *
     * @param {Object} options - The parameters for the documentation section.
     * @returns {HTMLElement} - The documentation section.
     */
    claim_documentation({ id = "documentation", required = false, ...params }) {
        if (Boolean(required) && required === false) {
            return;
        }

        const fieldset = createElement(
            "div",
            {
                id: id,
                class: "bg-light text-dark border rounded p-3 mb-5",
            },
            [],
            '<div class="h3 mb-3 formTitle">' + params.title + "</div>"
        );

        const fieldsetLead = createElement(
            "p",
            { class: "mb-3" },
            [],
            params.body
        );
        fieldset.appendChild(fieldsetLead);

        const notice = createElement(
            "p",
            { class: "mb-3" },
            [],
            params.file_types_notice
        );
        fieldset.appendChild(notice);
        const parInstructions = createElement(
            "p",
            { class: "text-center fw-bold mb-3" },
            [],
            params.instructions
        );
        fieldset.appendChild(parInstructions);

        // Documentation Inputs
        const fileInputId = `file-upload-${id}`;
        const fileInputLabel = createElement(
            "label",
            {
                for: fileInputId,
            },
            [],
            `${params.label_file_upload}: <span class=\"error\"></span><span class=\"warning\"></span>`
        );

        const validate = params.data_validate.split(" ");
        const isPaper = window.location.search.includes("paper_claim=true");

        const fileInput = createElement("input", {
            type: "file",
            id: fileInputId,
            class: "form-control mb-3",
            name: fileInputId,
            "data-input": params.data_input,
            "data-validate": isPaper
                ? validate.filter((item) => item !== "file-size").join(" ")
                : validate.join(" "),
            "data-file-size": params.data_file_size,
            "data-file-type": params.data_file_type,
            accept: params.accept,
        });
        const fileHashInput = createElement("input", {
            type: "hidden",
            id: `${id}-hash`,
        });
        const fileInputGroup = createElement(
            "div",
            {
                class: "mb-3",
            },
            [fileInputLabel, fileInput, fileHashInput]
        );
        fieldset.appendChild(fileInputGroup);

        const fileDescInputId = `file-description-${id}`;
        const fileDescInputLabel = createElement(
            "label",
            {
                for: fileDescInputId,
            },
            [],
            `${params.label_file_desc}: <span class="error"></span>`
        );
        const fileDescInput = createElement("input", {
            type: "text",
            class: "form-control",
            id: fileDescInputId,
            name: fileDescInputId,
            "file-label": params.data_file_label,
            "data-file-label": params.data_file_label,
        });
        const addFileBtn = createElement("input", {
            type: "button",
            class: "btn btn-primary",
            id: `file-add-${id}`,
            value: "Add File",
        });
        const inputGroup = createElement(
            "div",
            {
                class: "input-group input-group-lg mb-3",
            },
            [fileDescInput, addFileBtn]
        );
        const fileDescInputGroup = createElement(
            "div",
            {
                id: `groupFileDesc-${id}`,
            },
            [fileDescInputLabel, inputGroup]
        );
        fieldset.appendChild(fileDescInputGroup);

        const fileListPar = createElement(
            "p",
            {
                id: `fileList-${id}`,
            },
            [],
            `<strong>File List:</strong> <span id="no-files-${id}">No Files Selected</span>`
        );

        const fileOrderedList = createElement("ol", {
            class: "d-none",
            id: `file-list-${id}`,
        });
        const fileListElem = createElement(
            "div",
            {
                id: `fileListElem-${id}`,
            },
            [fileListPar, fileOrderedList]
        );
        fieldset.appendChild(fileListElem);

        this.supportingDocumentation[id] = new SupportingDocumentation(
            fieldset
        );

        return fieldset;
    }

    /**
     * Initializes the claim inputs.
     */
    init_claim_inputs() {
        super.init_claim_inputs();

        // We need to update the query selector for transaction inputs because we have reorganized the claim fields
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(
                ".transactions input, .transactions textarea, .transactions select"
            )
        );

        // Since we have reorganized the claim fields, we need to update the inputs
        this.claim.inputs.fields = this.formConfig.claim_fields
            .map((field) =>
                document.querySelector(
                    `input[name="${field.name}"], select[name="${field.name}"], textarea[name="${field.name}"]`
                )
            )
            .filter((input) => input != null)
            .concat(
                this.claim.inputs.fields.filter((input) =>
                    input.name.startsWith("payment_")
                )
            );
    }

    init_claim_inputs_loop() {
        for (const type in this.claim.inputs) {
            if (this.claim.inputs[type] && this.claim.inputs[type].length > 0) {
                this.claim.inputs[type].forEach(function (field) {
                    // Check for validation attribute
                    if (field.hasAttribute("data-validate")) {
                        // Attach change event handler for validation
                        field.addEventListener("change", function () {
                            validateField(field);
                        });
                    }
                });
            }
        }
    }

    claim_fields(params) {
        const container = createElement("div");

        let fieldID = 0; //
        params.claim_fields.forEach((field) => {
            const className = field.className ? field.className : ``;

            const div = createElement("div", {
                class: field.parentClass ? field.parentClass : "mb-3 _wrapper",
                "data-field-id":
                    "_" + (field.name ? field.name : "_wrapper_" + fieldID),
            });
            const element = FormFields(field, className, fieldID);
            FormFieldsLabel(field, fieldID, div);

            // Set data-label if it exists
            if (field.dataLabel) {
                element.setAttribute("data-label", field.dataLabel);
            }

            div.append(element);
            container.appendChild(div);
            fieldID++;
        });

        return container;
    }
    add_claim_file(e) {
        super.add_claim_file(e);
        if (this.customAddClaimFile) {
            this.customAddClaimFile(e);
        }
    }

    /**
     * Initialize the claim files for all documentation sections
     */
    init_claim_files() {
        for (const id in this.formConfig.claim_upload) {
            const inputFileId = `file-upload-${id}`;
            const inputFileDescId = `file-description-${id}`;
            const inputFileAddId = `file-add-${id}`;

            if (document.getElementById(inputFileId)) {
                document
                    .getElementById(inputFileId)
                    .addEventListener("change", function () {
                        if (validateField(this)) {
                            generateMd5Hash(this.files[0], id);
                            document.getElementById(inputFileDescId).focus();
                        }
                    });

                document
                    .getElementById(inputFileAddId)
                    .addEventListener("click", () => {
                        this.add_claim_file_with_suffix(id);
                    });

                document
                    .getElementById(inputFileDescId)
                    .addEventListener("keypress", (e) => {
                        if (["Enter", "NumpadEnter"].includes(e.code)) {
                            this.add_claim_file_with_suffix(id);
                            e.preventDefault();
                        }
                    });
            }
        }
    }

    /**
     * Add a claim file with the specified suffix
     *
     * @param {string} suffix - The suffix for the file upload elements
     */
    add_claim_file_with_suffix(suffix) {
        const claim = this.claim;
        const customAddClaimFile = this.customAddClaimFile;
        const file = document.getElementById(`file-upload-${suffix}`);
        const description = document.getElementById(
            `file-description-${suffix}`
        );
        const list = document.getElementById(`file-list-${suffix}`);
        const fileHash = document.getElementById(`${suffix}-hash`);

        if (file.classList.contains("error")) {
            return;
        }

        toggleFieldWarning(file, false);

        toggleFieldError(file, false);
        if (!file.files[0]) {
            toggleFieldError(file, true, "No File Selected");
            return;
        }

        description.value = description.value.trim();

        toggleFieldError(description, false);
        if (!description.value) {
            description.focus();
            toggleFieldError(description, true, "Required");
            return;
        }

        const li = document.createElement("li");
        li.innerHTML =
            '<span class="remove" style="cursor: pointer;"><i class="bi bi-x-circle text-danger d-inline-block float-end"></i><span></span></span><span class="filename"><strong>' +
            file.files[0].name +
            '</strong></span><span class="description">(' +
            description.value +
            ")</span>";
        list.appendChild(li);

        list.classList.remove("d-none");
        document.getElementById(`no-files-${suffix}`).classList.add("d-none");

        let doc_id = "";
        if (description.getAttribute("file-label")) {
            doc_id = description.getAttribute("file-label");
        }

        claim.uploads.push({
            file: file.files[0],
            description: description.value,
            hash: fileHash.value,
            doc_id: doc_id,
        });

        if (this.customAddClaimFile) {
            this.customAddClaimFile();
        }

        file.value = "";
        description.value = "";
        fileHash.value = "";

        li.querySelector(".remove").addEventListener("click", function () {
            const row = this.parentElement;
            const parent = row.parentElement;
            let added = parent.querySelectorAll("li:not([disabled])");
            const index = [].indexOf.call(added, row);
            const confirmText = `Are you sure you want to remove this file? \nFile Name: ${claim.uploads[index].file.name}\nDescription: ${claim.uploads[index].description}`;

            if (window.confirm(confirmText)) {
                parent.removeChild(row);
                claim.uploads.splice(index, 1);
                if (customAddClaimFile) {
                    customAddClaimFile();
                }
            }

            added = parent.querySelectorAll("li:not([disabled])"); // Recalculate after removal
            list.classList[added.length === 0 ? "add" : "remove"]("d-none");
            document
                .getElementById(`no-files-${suffix}`)
                .classList[added.length === 0 ? "remove" : "add"]("d-none");
        });
    }

    /**
     * Gets a claim field by name.
     *
     * @param {string} name - The name of the field.
     * @returns {HTMLInputElement} - The field element.
     */
    getFormInput(name) {
        const input = this.formElement.elements.namedItem(name);
        if (!input) {
            throw new Error(`Form input with name "${name}" not found`);
        }

        if (input instanceof RadioNodeList) {
            throw new Error(
                `Form input with name "${name}" is a RadioNodeList`
            );
        }

        return input;
    }

    /**
     * Gets a form radio input by name.
     *
     * @param {string} name - The name of the field.
     * @returns {RadioNodeList} - The radio node list.
     */
    getFormRadioInput(name) {
        const input = this.formElement.elements.namedItem(name);
        if (!(input instanceof RadioNodeList)) {
            throw new Error(
                `Form input with name "${name}" is not a RadioNodeList`
            );
        }

        return input;
    }

    /**
     * Handles the mutations.
     *
     * @param {MutationRecord[]} mutations - The mutations.
     */
    handleMutations(mutations) {
        mutations.forEach((mutation) => {
            if (
                mutation.type === "childList" &&
                Array.from(mutation.removedNodes).some(
                    (node) => node === this.formElement?.parentElement
                )
            ) {
                this.onFormUnloaded(this);
                this.observer.disconnect();
            }

            const addedRow = mutation.addedNodes.item(0);
            if (mutation.type === "childList" && addedRow?.tagName === "TR") {
                this.onTransactionRowAdded(addedRow);
            }

            const removedRow = mutation.removedNodes.item(0);
            if (mutation.type === "childList" && removedRow?.tagName === "TR") {
                this.onTransactionRowRemoved(removedRow);
            }
        });
    }

    /**
     * Process claim files including owner and transaction documentation
     *
     * @param {Object} claim - The claim object
     */
    process_claim_files(claim) {
        for (const id in this.formConfig.claim_upload) {
            const inputFileId = `file-upload-${id}`;

            if (document.getElementById(inputFileId)) {
                const inputFileError = document.querySelector(
                    `label[for="${inputFileId}"] .error`
                ).innerText;
                const inputFile = document.getElementById(inputFileId);

                toggleFieldWarning(inputFile, false);

                if (
                    inputFile.classList.contains("error") &&
                    inputFileError != "No File Selected"
                ) {
                    claim.flags.valid = false;
                } else if (inputFile.value != "") {
                    toggleFieldWarning(
                        inputFile,
                        true,
                        "Did you forget to add this file?"
                    );
                    claim.flags.valid = false;
                } else {
                    toggleFieldError(inputFile, false);
                }
            }
        }
    }

    confirmation_claim_transactions(params) {
        const transactions = params.transactions;
        const fieldsContainer = createElement("div", {
            class: "mb-3",
            id: "confirmation_claim_transactions",
        });
        Object.keys(transactions).forEach((index) => {
            Object.keys(transactions[index]).forEach((key) => {
                if (transactions[index][key]) {
                    const rawValue = transactions[index][key];
                    const strippedValue = String(rawValue).replace(/,/g, "");
                    const isNumeric =
                        rawValue !== "" &&
                        /^\d*\.?\d+$/.test(strippedValue);
                    const displayValue = isNumeric
                        ? formatWithThousandsSeparator(rawValue)
                        : rawValue;
                    const row = createElement(
                        "div",
                        {
                            class: "row mb-3 pb-3 border-bottom",
                        },
                        [
                            createElement(
                                "div",
                                { class: "col fw-bold text-end" },
                                [],
                                key
                            ),
                            createElement(
                                "div",
                                { class: "col" },
                                [],
                                displayValue
                            ),
                        ]
                    );
                    fieldsContainer.appendChild(row);
                }
            });
        });
        return fieldsContainer;
    }

    confirmation_claim_member(params) {
        console.log("[confirmation_claim_member]");
        const fields = params.contact;
        const fieldsContainer = createElement("div", {
            class: "mb-3",
            id: "confirmation_claim_member",
        });
        Object.keys(fields).forEach((key) => {
            if (key === "ag_PAPER") return; // skip ag_PAPER
            if (
                fields[key] &&
                document.getElementById(key).getAttribute("data-contact-label")
            ) {
                const row = createElement(
                    "div",
                    {
                        class: "row mb-3 pb-3 border-bottom",
                    },
                    [
                        createElement(
                            "div",
                            { class: "col fw-bold text-end" },
                            [],
                            document
                                .getElementById(key)
                                .getAttribute("data-contact-label")
                        ),
                        createElement("div", { class: "col" }, [], fields[key]),
                    ]
                );
                fieldsContainer.appendChild(row);
            }
        });
        return fieldsContainer;
    }

    /**
     * Skip the one-time passcode in every environment.
     *
     * send_otp is called from both edit_claim and init_claim above, so
     * overriding it here covers both without touching the shared base. Access
     * to the edit-claim portal is gated by the Notice ID + Confirmation Code
     * guard alone.
     */
    send_otp(form, container, class_member, claim_deadline) {
        console.log("[send_otp] skipping OTP");
        document.querySelector('[data-bs-dismiss="modal"]')?.click();
        this.populate_claim_form(form, container, class_member, claim_deadline);
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");

        /**
         * Remember the lookup response so post_claim can route the submission.
         *
         * isExistingClaimResponse is true exclusively for the claim row
         * getClassMember returns for a member who already has an editable
         * claim, so a generic / new claim is never marked as an edit.
         */
        if (class_member) {
            this.claim.class_member = this.claim.class_member || class_member;
            if (isExistingClaimResponse(class_member)) {
                this.claim.flags.editing = true;
            }
        }

        if (this.expectedClaimFormType) {
            const claimFields = class_member.claim_fields || [];
            const formTypeField = claimFields.find(
                (f) => f.name === "Claim Form Type"
            );
            const actualType = formTypeField ? formTypeField.value : null;
            if (actualType !== this.expectedClaimFormType || class_member.claim_type !== 'generic') {
                loadingGif(loading, "hide", 250);
                const message = 'This claim cannot be edited.'
                modal(i18n.getTranslation("error"), message);
                return;
            }
        }

        // set user for error tracking
        this.errorHandler.set_user({
            id: class_member.zero_zero_id,
            email: class_member.email_address,
        });
        // remove guard -- may already be gone when OTP was skipped
        document.getElementById("guard")?.remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M.
        const deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // hide loading gif
        loadingGif(loading, "hide", 250);
        // Load member data into form
        loadMember(class_member, this.formConfig["claim_upload"]);
        // custom login member code
        if (this.customLoadMember != null) {
            this.customLoadMember(this.claim);
        }
        // Payment widget
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }
        this.setup_country_field_toggle();
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    /**
     * Post the claim to the backend
     *
     * @param {Object} claim - The claim object.
     * @param {Object} s3env - The s3 environment object.
     * @returns {void}
     */
    async post_claim(claim, s3env) {
        console.log("[post_claim]");

        /**
         * Set the claim as sent.
         *
         * @returns {void}
         */
        claim.flags.sent = true;

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Removed: 2023.09.25 (moved to process_claim) due to multiple submissions.
         *
         * @returns {void}
         */
        // document.getElementById('submit-claim').disabled = true;

        /**
         * Wait 0.5 seconds before display loading gif
         * (Lambda in sleep mode)
         *
         * @returns {void}
         */
        const t = window.setTimeout(() => {
            loadingGif(loading, "show");
        }, 250);

        // Update claim if an existing claim id. resolveClaimId also reads
        // claim.class_member, so a lookup response that carried the id survives
        // even when claim.data.claim_id was never populated.
        const claimId = resolveClaimId(claim);
        if (claimId) {
            claim.data.claim_id = claimId;
            claim.flags.method = "claimsPut";
        } else if (claim.flags.editing) {
            /**
             * An edit with no resolvable claim id would go out as a POST, and
             * postClaim would abandon it on the duplicate-key catch without
             * telling the claimant. Fail loudly instead of silently.
             */
            clearTimeout(t);
            claim.flags.sent = false;
            claim.flags.success = false;
            this.errorHandler.log_exception(
                new Error(
                    `Editing claim ${claim.data.zero_zero_id} but no claim_id could be resolved; refusing to POST over an existing claim`
                )
            );
            loadingGif(loading, "hide", 250);
            document.getElementById("submit-claim").disabled = false;
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_processing_error")
            );
            return;
        }

        /**
         * Process the claim uploads and upload the files.
         */
        try {
            if (claim.uploads.length && claim.uploads.length > 0) {
                for (let f = 0; f < claim.uploads.length; f++) {
                    await uploadFile(claim, s3env, claim.uploads[f], f, 0);
                }
            }
        } catch (error) {
            this.errorHandler.log_exception(
                new Error("Error uploading claim files", { cause: error })
            );
            this.errorHandler.display_modal(error);
        }

        /**
         * Paul Pomerleau - October 18th, 2023
         * If the device has a local device token it's added to the claim fields before posting
         */
        const deviceToken = localStorage.getItem("X-Device-Token");
        if (deviceToken) claim.data.fields.device_token = deviceToken;

        // Post/Put claims data
        claim.api[claim.flags.method]({}, claim.data)
            .then(async function (result) {
                // Lambda error message
                if (result.data.error) {
                    clearTimeout(t);
                    claim.flags.success = false;
                    modal(i18n.getTranslation("error"), result.data.error);
                    return;
                }

                /**
                 * Save correlation id
                 *
                 * putClaim responds with {claim_id, zero_zero_id,
                 * confirmation_code} and no correlation_id, so assigning
                 * unconditionally would blank the confirmation number the
                 * lookup already gave us.
                 */
                if (result.data.correlation_id) {
                    claim.data.correlation_id = result.data.correlation_id;
                }
                claim.flags.success = true;
            })
            .catch((error) => {
                const cause = new Error(
                    error?.data?.error ?? error?.message ?? error
                );
                const wrappedError = new Error("Error posting claim", {
                    cause,
                });

                // Combine stack traces for better context
                const currentStack = new Error().stack;
                wrappedError.stack = `${wrappedError.stack}\n\nCaused by:\n${error.stack || currentStack}`;

                this.errorHandler.log_exception(wrappedError);
                this.errorHandler.display_modal(error);
                claim.flags.success = false;
            })
            .finally(() => {
                // duplicate submission guard: clear submission guid if it is set
                this.clearSubmissionGuid();

                clearTimeout(t);
                loadingGif(loading, "hide", 250);
                if (claim.flags.success) {
                    this.destroy_claim(claim);
                } else {
                    document.getElementById("submit-claim").disabled = false;
                    claim.flags.sent = false;
                }

                // Remove editClaim link on Claim Confirmation
                const editClaim = document.getElementById("editClaim");
                if (editClaim !== null) {
                    editClaim.remove();
                }
            });
    }

    /**
     * Clear the submission guid.
     *
     * @returns {void}
     */
    clearSubmissionGuid() {
        const hasSubmissionGuid =
            window.location.search.includes("submission_guid") ||
            localStorage.getItem("_ag_SGUID");
        if (hasSubmissionGuid) {
            localStorage.removeItem("_ag_SGUID");
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.delete("submission_guid");
            window.history.replaceState(
                {},
                "",
                `${window.location.pathname}?${urlParams.toString()}`
            );
        }
    }
}

/**
 * Initialize the claim.
 *
 * @this {CustomSubmitClaim}
 * @param {Function} validateForm - The validate form function.
 * @returns {Object} The claim object.
 */
export function handleInitClaim(validateForm) {
    const { formElement } = this;
    const handleEvent = (event) => validateForm({ event, ctx: this });

    formElement.addEventListener("input", handleEvent);

    // initial validation
    validateForm({ ctx: this, event: "init_claim" });

    // cleanup
    window.addEventListener("beforeunload", () => {
        formElement.removeEventListener("input", handleEvent);
    });

    return this.claim;
}

/**
 * Processes the claim.
 *
 * @this {CustomSubmitClaim}
 * @param {Function} validateForm - The validate form function.
 * @returns {Object} The processed claim.
 */
export function handleProcessClaim(validateForm) {
    validateForm({ ctx: this, event: "process_claim" });
    return this.claim;
}

/**
 * Adds a claim file.
 *
 * @this {CustomSubmitClaim}
 * @param {Function} validateForm - The validate form function.
 * @returns {void}
 */
function handleAddClaimFile(validateForm) {
    validateForm({ ctx: this, event: "add_claim_file" });
}

/**
 * Generate an MD5 hash for the given file.
 *
 * @param {File} file - The file to generate the hash for.
 * @param {string} id - The id of the file input.
 * @returns {void}
 */
export function generateMd5Hash(file, id) {
    const blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
    const chunkSize = 2097152; // Read in chunks of 2MB
    const chunks = Math.ceil((file?.size ?? 0) / chunkSize);
    let currentChunk = 0;
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();
    const fileHash = document.getElementById(`${id}-hash`);

    // claim.loading.classList.add('show');

    fileReader.onload = function (e) {
        spark.append(e.target.result); // Append array buffer
        currentChunk++;

        if (currentChunk < chunks) {
            loadNext();
        } else {
            // claim.loading.classList.remove('show');
            fileHash.value = spark.end();
        }
    };

    fileReader.onerror = function () {
        // claim.loading.classList.remove('show');
        console.warn("oops, something went wrong.");
    };

    /**
     * Load the next chunk of the file.
     *
     * @returns {void}
     */
    function loadNext() {
        const start = currentChunk * chunkSize,
            end =
                start + chunkSize >= file?.size
                    ? file?.size
                    : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }

    loadNext();
}

export function validateField(e) {
    const field = e instanceof Event ? e.target : e;

    if (!field.hasAttribute("data-validate")) {
        return;
    }

    // Check if this is an intl-phone-input custom element
    if (field.tagName?.toLowerCase() === "intl-phone-input") {
        return field.validate();
    }

    // Check if this is an ssn-input custom element
    if (field.tagName?.toLowerCase() === "ssn-input") {
        return field.validate();
    }

    const validation = field.getAttribute("data-validate").split(" ");

    // File input element values can't be changed (except to empty string)
    if (field.type != "file") {
        field.value = field.value.trim();
    }

    if (
        field.hasAttribute("data-custom-validate") &&
        typeof customValidateField === "function"
    ) {
        return customValidateField(field, validation);
    }

    toggleFieldError(field, false);

    if (validation.includes("required") && !validRequire(field)) {
        toggleFieldError(field, true, i18n.getTranslation("required"));
        return false;
    }

    if (field.value) {
        if (validation.includes("integer") && !validInteger(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("float") && !validFloat(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("price") && !validPrice(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (field.min && !validMin(field)) {
            toggleFieldError(field, true, `Must be at least ${field.min}`);
            return false;
        }

        if (field.max && !validMax(field)) {
            toggleFieldError(field, true, `Must be at most ${field.max}`);
            return false;
        }

        if (validation.includes("email") && !validEmail(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("url") && !validURL(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("min-length") && !validMinLength(field)) {
            toggleFieldError(
                field,
                true,
                "Min Length: " + field.getAttribute("data-min-length")
            );
            return false;
        }

        if (validation.includes("max-length") && !validMaxLength(field)) {
            toggleFieldError(
                field,
                true,
                "Max Length: " + field.getAttribute("data-max-length")
            );
            return false;
        }

        if (validation.includes("zip-code") && !validZipCode(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("phone") && !validPhone(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("file-type") && !validFileType(field)) {
            toggleFieldError(field, true, "Invalid File Type");
            return false;
        }

        if (validation.includes("file-size") && !validFileSize(field)) {
            toggleFieldError(
                field,
                true,
                "Max File Size: " +
                    field.getAttribute("data-file-size") / 1048576 +
                    " Mb"
            );
            return false;
        }

        if (validation.includes("month") && !validMonth(field)) {
            toggleFieldError(field, true, "Must be in format MM/YYYY");
            return false;
        }

        if (validation.includes("date") && !validDate(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("date-min") && !validMinDate(field)) {
            toggleFieldError(
                field,
                true,
                `Minimum date is ${formatDate(new Date(field.getAttribute("data-date-min")))}`
            );
            return false;
        }

        if (validation.includes("date-max") && !validMaxDate(field)) {
            toggleFieldError(
                field,
                true,
                `Maximum date is ${formatDate(new Date(field.getAttribute("data-date-max")))}`
            );
            return false;
        }

        if (validation.includes("greater-than") && !validGreaterThan(field)) {
            toggleFieldError(field, true, "Invalid"); //'Greater Than: '+field.getAttribute('data-greater-than'));
            return false;
        }

        if (validation.includes("less-than") && !validLessThan(field)) {
            toggleFieldError(field, true, "Invalid"); //'Less Than: '+field.getAttribute('data-less-than'));
            return false;
        }

        if (validation.includes("regex") && !validRegex(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }
    }

    return true;
}

/**
 * Validate Email
 *
 * @param {HTMLInputElement} field - The field to validate.
 * @returns {boolean} True if the field is valid, false otherwise.
 */
function validEmail(field) {
    const email =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-_0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email.test(field.value) ? true : false;
}

/**
 * Format a date.
 *
 * @param {Date} date - The date to format.
 * @returns {string} The formatted date.
 */
function formatDate(date) {
    return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}
